// Google Analytics 4 — official Google tag (gtag.js).
//
// Ownership model: our code is the single source of page views. The base tag is
// loaded with send_page_view:false (so the config command emits nothing), and a
// React Router tracker (GaPageViews) sends exactly one page_view for the initial
// location and one for each subsequent route change. Enhanced Measurement's
// "page changes based on browser history events" should remain OFF so there is
// no double counting.
//
// The Measurement ID is configurable via REACT_APP_GA_MEASUREMENT_ID. Analytics
// only runs on the production host (REACT_APP_GA_PRODUCTION_HOST, default
// mylimya.com) so preview/dev traffic never pollutes the production property.

const MEASUREMENT_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();
const PRODUCTION_HOST = (process.env.REACT_APP_GA_PRODUCTION_HOST || "mylimya.com").trim();

export const analyticsEnabled =
  typeof window !== "undefined" &&
  Boolean(MEASUREMENT_ID) &&
  window.location.hostname === PRODUCTION_HOST;

export function initAnalytics() {
  if (!analyticsEnabled) return;
  if (window.__gaInitialized) return;
  window.__gaInitialized = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  // Default config emits the initial page_view; GA4 Enhanced Measurement owns
  // SPA route page views (history events). Single source => no double counting.
  gtag("config", MEASUREMENT_ID);
}
